import { useContext, useMemo } from "react";

import CurrentStackableContext from "./CurrentStackableContext";
import StackableContext from "./StackableContext";

export const useStackables = () => {
  return useContext(StackableContext);
};

export const useCurrentStackable = (opts: { type: string }) => {
  const { type, remove, isFocused } = useContext(CurrentStackableContext);
  return useMemo(
    () => ({
      close: () => {
        if (type !== opts.type) {
          console.warn("Close not called from a modal context");
        } else {
          remove();
        }
      },
      isFocused,
    }),
    [type, opts.type, remove, isFocused],
  );
};
